package flashcards

import kotlinx.serialization.Serializable


@Serializable
data class FlashCard(val questionText: String, val answerText: String)